import Vue from 'vue'
import Vuex from 'vuex'
import event from './event-store'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    base_url : "https://sportips.fr/api/v1/resultats/endpoints",
  },
  mutations: {

  },
  getters : {
    base_url : state => state.base_url,
  },

  actions: {
  },
  modules: {
    event
  }
})
